<template>
  <div class="text-center p-0" :class="container && 'container py-5'">
    <div class="cv-buttons text-left">
      <mdb-btn color="elegant" @click="container = !container"
        >Toggle container</mdb-btn
      >
      <router-link to="/"
        ><mdb-btn color="elegant">Home page</mdb-btn></router-link
      ><br />
    </div>
    <div ref="cv" class="cv" :style="computedCVHeight">
      <mdb-row class="cv-row">
        <mdb-col col="4" class="cv-left-col">
          <div class="d-flex justify-content-center align-items-center">
            <div class="cv-photo-wrapper">
              <img src="@/assets/cv.png" class="cv-photo" alt="Photo" />
            </div>
          </div>
          <br />
          <h5 class="mt-5">Personal</h5>
          <hr />
          <table>
            <tr>
              <td width="40%">Name</td>
              <td class="grey-text">Mikołaj Smoleński</td>
            </tr>
            <tr>
              <td width="40%">Date of Birth</td>
              <td class="grey-text">3th March 1991</td>
            </tr>
          </table>

          <h5 class="mt-5">Contact</h5>
          <hr />
          <table>
            <tr>
              <td width="40%">Website</td>
              <td class="grey-text">
                <a href="https://smolenski-mikolaj.pl/" target="_blank"
                  >smolenski-mikolaj.pl</a
                >
              </td>
            </tr>
            <tr>
              <td width="40%">Mail</td>
              <td class="grey-text">smolenski.mikolaj@gmail.com</td>
            </tr>
            <tr>
              <td width="40%">Phone</td>
              <td class="grey-text">+48 602 18 16 17</td>
            </tr>
            <tr>
              <td width="40%">Location</td>
              <td class="grey-text">Warsaw, PL</td>
            </tr>
            <tr>
              <td width="40%">Timezone</td>
              <td class="grey-text">CET</td>
            </tr>
          </table>

          <h5 class="mt-5">Work</h5>
          <hr />
          <table>
            <tr>
              <td width="40%">IT experience</td>
              <td class="grey-text" v-if="experience[experience.length - 1]">
                {{
                  new Date()
                    | moment(
                      'diff',
                      new Date(experience[experience.length - 1].from.toDate()),
                      'years'
                    )
                }}
                years
              </td>
            </tr>
            <tr>
              <td width="40%">Geodesy exp.</td>
              <td class="grey-text">1 year</td>
            </tr>
            <tr>
              <td width="40%">English level</td>
              <td class="grey-text">B2</td>
            </tr>
          </table>

          <h5 class="mt-5">Links</h5>
          <hr />
          <mdb-row
            class="d-flex justify-content-center text-center grey-text px-2 skills"
          >
            <div class="d-flex flex-column mt-3 mx-3">
              <a
                href="https://github.com/smolenski-mikolaj"
                target="_blank"
                class="grey-text d-flex flex-column"
                ><mdb-icon brands size="lg" icon="github" /><small
                  >GitHub</small
                ></a
              >
            </div>
            <div class="d-flex flex-column mt-3 mx-3">
              <a
                href="https://www.linkedin.com/in/miko%C5%82aj-smole%C5%84ski/"
                target="_blank"
                class="grey-text d-flex flex-column"
                ><mdb-icon brands size="lg" icon="linkedin" /><small
                  >LinkedIn</small
                ></a
              >
            </div>
          </mdb-row>

          <h5 class="mt-5">Skills</h5>
          <hr />
          <mdb-row
            class="d-flex justify-content-center text-center grey-text px-2 skills"
          >
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="js" />
              <small>JavaScript</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="vuejs" />
              <small>Vue</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="react" />
              <small>React</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="node" />
              <small>Node</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="mdb" />
              <small>MDB</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="html5" />
              <small>HTML</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="css3" />
              <small>CSS</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="sass" />
              <small>Sass</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="git" />
              <small>Git</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="php" />
              <small>PHP</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="trello" />
              <small>Trello</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="slack" />
              <small>Slack</small>
            </div>
            <div class="d-flex flex-column m-3">
              <mdb-icon brands icon="confluence" />
              <small>Confluence</small>
            </div>
          </mdb-row>
          <div class="clause grey-text" v-if="clause">{{ clause.text }}</div>
        </mdb-col>

        <mdb-col col="8" class="cv-right-col">
          <h1 class="font-weight-bold mb-0">Mikołaj Smoleński</h1>
          <p>Frontend Developer</p>
          <section v-if="about">
            <div class="heading-wrapper">
              <div class="d-flex align-items-center float-left">
                <div
                  class="d-flex justify-content-center align-items-center rounded-circle icon-wrapper"
                >
                  <mdb-icon icon="address-card" />
                </div>
              </div>
              <h4 class="font-weight-bold float-left pl-3">About Me</h4>
            </div>
            <hr />
            <p class="pt-2" v-html="about.description"></p>
          </section>
          <section v-if="experience">
            <div class="heading-wrapper">
              <div class="d-flex align-items-center float-left">
                <div
                  class="d-flex justify-content-center align-items-center rounded-circle icon-wrapper"
                >
                  <mdb-icon icon="briefcase" />
                </div>
              </div>
              <h4 class="font-weight-bold float-left pl-3">IT Experience</h4>
            </div>
            <hr />

            <div
              v-for="(exp, key) in experience"
              :key="key"
              class="d-flex mb-2 experience-item"
            >
              <div class="d-flex flex-column">
                <h6 v-if="exp.name" class="mt-1 mb-0 font-weight-bold">
                  <a
                    v-if="exp.href"
                    :href="exp.href"
                    target="_blank"
                    class="black-text"
                    >{{ exp.name }}</a
                  >
                  <span v-else>{{ exp.name }}</span>
                </h6>
                <p class="mb-0" :class="{ 'mt-2': !exp.name }">
                  {{ exp.position }}
                </p>
                <small class="mb-0 bg-light px-2 py-1 badge-custom">
                  <span>{{ exp.from.toDate() | moment('MMM YYYY') }}</span>
                  <span> - </span>
                  <span v-if="exp.to">{{
                    exp.to.toDate() | moment('MMM YYYY')
                  }}</span>
                  <span v-else>currently</span>
                </small>
              </div>
              <small class="d-flex flex-column justify-content-center">
                {{ exp.description }}
              </small>
            </div>
          </section>

          <section v-if="projects">
            <div class="heading-wrapper">
              <div class="d-flex align-items-center float-left">
                <div
                  class="d-flex justify-content-center align-items-center rounded-circle icon-wrapper"
                >
                  <mdb-icon icon="pencil-alt" />
                </div>
              </div>
              <h4 class="font-weight-bold float-left pl-3">Projects</h4>
            </div>
            <hr />

            <div
              v-for="(project, key) in reversedCommercialProjects"
              :key="'2' + key"
            >
              <h6 class="mt-3 mb-0 font-weight-bold">
                <a class="black-text" :href="project.href" target="_blank">{{
                  project.title
                }}</a>
              </h6>
              <small class="mb-0">{{ project.stack }}</small>
              <br />
              <small class="mb-0 bg-light px-2 py-1 badge-custom">
                Commercial
              </small>
            </div>

            <div v-for="(project, key) in projects" :key="'3' + key">
              <div v-if="key < 3">
                <h6 class="mt-3 mb-0 font-weight-bold">
                  <a class="black-text" :href="project.href" target="_blank">{{
                    project.title
                  }}</a>
                </h6>
                <small class="mb-0">{{ project.stack }}</small>
                <br />
                <small class="mb-0 bg-light px-2 py-1 badge-custom">
                  Private
                </small>
              </div>
            </div>
          </section>

          <section v-if="education">
            <div class="heading-wrapper">
              <div class="d-flex align-items-center float-left">
                <div
                  class="d-flex justify-content-center align-items-center rounded-circle icon-wrapper"
                >
                  <mdb-icon icon="graduation-cap" />
                </div>
              </div>
              <h4 class="font-weight-bold float-left pl-3">Education</h4>
            </div>
            <hr />

            <div v-for="(edu, key) in education" :key="'1' + key">
              <h6 class="mt-3 mb-0 font-weight-bold" v-html="edu.title"></h6>
              <p v-if="edu.subtitle" class="mb-0">{{ edu.subtitle }}</p>
              <small class="mb-0 bg-light px-2 py-1 badge-custom"
                >{{ edu.from.toDate() | moment('MMM YYYY') }} -
                {{ edu.to.toDate() | moment('MMM YYYY') }}</small
              >
            </div>
          </section>
        </mdb-col>
      </mdb-row>
    </div>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbIcon, mdbBtn } from 'mdbvue'
import { db } from '../main'

export default {
  name: 'CV',
  components: {
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
  },
  data() {
    return {
      cvWidth: 'auto',
      about: [],
      projects: [],
      commercialProjects: [],
      experience: [],
      education: [],
      clause: null,
      container: true,
    }
  },
  firestore() {
    return {
      about: db.collection('basicData').doc('about'),
      projects: db.collection('projects'),
      commercialProjects: db.collection('commercialProjects'),
      experience: db.collection('experience').orderBy('from', 'desc'),
      education: db.collection('education').orderBy('from', 'desc'),
      clause: db.collection('cv').doc('clause'),
    }
  },
  computed: {
    computedCVHeight() {
      let newHeight = 'auto'
      if (this.cvWidth !== '100%') {
        newHeight = this.cvWidth * 1.39 + 'px'
      }

      return {
        height: newHeight,
      }
    },
    reversedCommercialProjects() {
      return this.commercialProjects.slice().reverse()
    },
  },
  mounted() {
    this.countCVHeight()
    window.addEventListener('resize', this.countCVHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.countCVHeight)
  },
  methods: {
    countCVHeight() {
      if (window.outerWidth > 992) {
        this.cvWidth = this.$refs.cv.clientWidth
      } else {
        this.cvWidth = '100%'
      }
    },
  },
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: rgb(158, 158, 158);
}
.cv-buttons {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 5;
}
.cv {
  width: 100%;
  background-color: white;
  box-shadow: 2px 2px 10px grey;
  overflow: hidden;
}
.cv-row {
  margin: 0;
  height: 100%;
}
.cv-left-col {
  background-color: #2b2b2b;
  height: 100%;
  padding: 5rem 2rem 5rem 2rem;
  text-align: left;
}
.cv-right-col {
  color: #2b2b2b;
  height: 100%;
  padding: 2rem 3rem;
  text-align: left;
}
.cv-photo-wrapper {
  max-width: 200px;
  border-radius: 50%;
  background-color: #333333;
}
.cv-photo {
  width: 100%;
  max-width: 200px;
  height: auto;
  border-radius: 50%;
}
.cv-left-col table {
  width: 100%;
}
.cv-left-col table td:first-child {
  font-size: 12px;
}
.cv-left-col table td:last-child {
  font-size: 11px;
}
.cv-left-col hr {
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.clause {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 5rem 2rem 2rem 2rem;
  font-size: 8px;
}
.experience-item {
  gap: 10px;
}
.experience-item .flex-column:first-child {
  width: 600px;
}
.experience-item .flex-column:last-child {
  color: #6d6d6d;
  text-align: right;
  text-wrap: balance;
  font-size: 11px;
}

section {
  margin: 30px 0;
  position: relative;
}
section .heading-wrapper {
  position: relative;
  background-color: white;
  display: inline-block;
  z-index: 2;
  padding-right: 1.5rem;
}
section hr {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
section hr:after {
  content: '';
  position: absolute;
  top: -2px;
  right: 0;
  width: 10%;
  border-top: 4px solid #2b2b2b;
}
section p {
  color: #6d6d6d;
  font-size: 14px;
}
section small {
  color: #6d6d6d;
}
section .icon-wrapper {
  height: 35px;
  width: 35px;
  border: 1px solid #2b2b2b;
  margin-top: -3px;
}
.skills i {
  font-size: 22px;
}
.skills small {
  padding-top: 2px;
  font-size: 10px;
}
.badge-custom {
  border-radius: 20px;
  font-size: 70%;
  max-width: fit-content;
}

@media print {
  .cv-buttons {
    display: none;
  }
}
</style>
